<template>
    <div class="shoplist-page">
        <div class="brand-info-wrapper">
            <img
                v-if="init"
                :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${brandInfo.logo}`"
                width="40"
            />
            <p>{{ brandInfo.name }}</p>
            <span class="switch-brand" @click="goBrandList">切换品牌</span>
        </div>
        <div class="shop-list-wrapper">
            <van-search
                v-model="params.realNameLike"
                show-action
                placeholder="搜索"
                @search="onSearch"
                @clear="onSearch"
            >
                <template #action>
                    <div class="search-btn" @click="onSearch">
                        <van-icon name="search" color="#fff" />
                    </div>
                </template>
            </van-search>
            <p class="list-tip">店铺列表</p>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                >
                    <div v-for="item in list" :key="item.id" class="shop-box">
                        <div class="img-box">
                            <img src="../../assets/jike/bshop.png" width="40" />
                        </div>
                        <div class="shop-info-box">
                            <p class="shop-name info-inline">
                                {{ item.realName }}
                            </p>
                            <p>
                                <img
                                    class="samall"
                                    src="../../assets/jike/map.png"
                                    alt=""
                                />{{ item.name }} {{ item.phone }}
                            </p>
                            <p class="info-inline">
                                <img
                                    class="samall"
                                    src="../../assets/jike/phone.png"
                                    alt=""
                                />{{ item.province }}{{ item.city
                                }}{{ item.district }}{{ item.address }}
                            </p>
                        </div>
                        <button
                            class="shop-choose-btn"
                            @click="getTaskByShop(item)"
                        >
                            选择店铺
                        </button>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>
<script>
import {
    fetchAddresses,
    fetchBrandById,
    fetchBrandsSelectionBox,
} from "../../services/instant";
import Cookies from "js-cookie";

export default {
    name: "ShopList",
    data() {
        return {
            init: false,
            brandInfo: {},
            value: "",
            list: [],
            loading: false,
            finished: true,
            refreshing: false,
            params: {
                realNameLike: "",
                current: 1,
                size: 10,
                brandId: "",
                type: 20,
            },
            total: 0,
            brandParams: {
                current: 1,
                size: 10,
            },
        };
    },
    created() {
        const token = Cookies.get("token");
        if (token) {
            const data = this.$route.query;
            if (data.brandId) {
                this.params.brandId = data.brandId;
                this.getData();
            } else {
                // 没有带品牌id
                fetchBrandsSelectionBox(this.brandParams).then((res) => {
                    this.params.brandId =
                        res.data.records.length > 0
                            ? res.data.records[0].id
                            : "";
                    this.getData();
                });
            }
            // this.onLoad()
        } else {
            this.goLogin();
        }
    },
    methods: {
        goLogin() {
            const toPath = this.$route.path;
            this.$router.push(`/login?redirect=${toPath}`);
        },
        getData() {
            this.finished = false;
            fetchBrandById(this.params.brandId).then((res) => {
                this.init = true;
                this.brandInfo = res.data;
            });
        },
        getTaskByShop(item) {
            Cookies.set("shopId", item.id);
            this.$router.push({
                path: "/shopDetail",
                query: {
                    id: item.id,
                    // brandLogo: this.brandInfo.logo,
                    // shopName: item.realName
                },
            });
        },
        // 切换品牌
        goBrandList() {
            this.$router.push("/brandList");
        },
        onLoad() {
            setTimeout(() => {
                if (this.refreshing) {
                    this.list = [];
                    this.params.current = 1;
                    this.refreshing = false;
                }
                fetchAddresses(this.params).then((res) => {
                    console.log(res, res.total);
                    this.list = this.list.concat(res.records);
                    console.log(this.list);
                    this.total = res.total;
                    this.params.current++;
                    this.loading = false;
                    if (this.list.length >= this.total) {
                        this.finished = true;
                    }
                });
            }, 0);
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
        },
        onSearch() {
            this.list = [];
            this.params.current = 1;
            this.onLoad();
        },
    },
};
</script>
<style lang="less">
.samall {
    height: 16px;
    width: 16px;
    position: relative;
    top: 3px;
    right: 2px;
}
.van-search__content {
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 7px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: #ffffff;
    .van-icon {
        color: #ff6d26;
    }
}
.van-search .van-cell {
}
</style>
<style lang="less" scoped>
.shoplist-page {
    background: #f1f1f1;
    .search-btn {
        width: 34px;
        height: 34px;
        background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
        border-radius: 7px;
        text-align: center;
        .van-icon {
            font-size: 18px;
            vertical-align: middle;
            font-weight: bold;
        }
    }
    .shop-list-wrapper {
        padding: 0 15px;
        background: white;
        .list-tip {
            font-weight: bold;
            color: #000000;
            border-bottom: 1px solid #dadada;
            line-height: 40px;
        }
        .shop-box {
            position: relative;
            padding: 10px 0 26px;
            //display: flex;
            border-bottom: 1px solid #dadada;

            .img-box {
                display: table-cell;
                padding: 0 15px 0 10px;
                vertical-align: middle;
            }
            .shop-choose-btn {
                position: relative;
                top: -10px;
                //width: 60px;
                height: 25px;
                background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
                border-radius: 3px;
                color: #ffffff;
                font-size: 12px;
                border: none;
                float: right;
            }
            .switch-shop-btn {
                position: absolute;
                cursor: pointer;
                color: #1677ff;
                font-size: 12px;
                right: 20px;
                top: 10px;
                line-height: 20px;
            }

            .shop-info-box {
                display: table-cell;
                width: 220px;

                p {
                    margin: 0;
                    line-height: 24px;

                    &.shop-name {
                        font-size: 14px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 24px;
                    }
                    &.info-inline {
                        display: inline-flex;
                    }
                    &:nth-of-type(2) {
                        line-height: 30px;
                    }
                    &:nth-of-type(3) {
                        line-height: 20px;
                    }
                    &:nth-of-type(2),
                    &:nth-of-type(3) {
                        font-size: 12px;
                        color: #999999;
                        //line-height: 20px;
                    }
                }
            }
        }
    }
}
.brand-info-wrapper {
    padding: 40px 0 20px;
    background: #ffffff;
    text-align: center;
    margin-bottom: 8px;
    p {
        margin: 0;
    }
    img {
        width: 60px;
        height: 60px;
        border-radius: 30px;
    }
    .switch-brand {
        position: absolute;
        font-size: 12px;
        color: #1677ff;
        cursor: pointer;
        right: 10px;
        top: 10px;
    }
}
</style>
